import styled from 'styled-components';
import { color, typography } from 'styles/settings';
import { withModifiers } from 'utils/styles';

export const StyledLabel = styled.span`
  color: ${color.neutral.grayDark};
  font-size: ${({ fontSize }) => fontSize && typography.size.rg};
  margin-bottom: 4px;
  /* stylelint-disable-line */
  ${withModifiers('invalid')`
    border-color: ${color.ui.danger};
    color: ${color.ui.danger};
  `};
  /* stylelint-enable-line */
`;
